import React, { useState } from 'react';
import { Mail, CheckCircle, RefreshCw, ArrowLeft } from 'lucide-react';
import { BRAND_CONFIG } from '../../config/brand';
// import { authService } from '../../lib/supabase'; // 暫時未使用

interface EmailConfirmationProps {
  email: string;
  onBack: () => void;
  onSuccess: () => void;
}

export const EmailConfirmation: React.FC<EmailConfirmationProps> = ({ email, onBack }) => {
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');

  const handleResendEmail = async () => {
    setIsResending(true);
    setResendMessage('');

    try {
      // 由於 Supabase 沒有直接的重發確認郵件 API，
      // 我們提供登入指引或重設密碼選項
      setResendMessage('如果您忘記密碼，可以使用「忘記密碼」功能。否則請在確認郵件後直接登入。');
    } catch (err) {
      setResendMessage('操作時發生錯誤');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-white rounded-xl shadow-lg shadow-wedding-pink/20 p-8">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center w-16 h-16 bg-wedding-action/10 rounded-full mx-auto mb-4">
            <Mail className="w-8 h-8 text-wedding-action" />
          </div>
          <h1 className="text-2xl font-bold text-wedding-text-title mb-2">檢查您的電子郵件</h1>
          <p className="text-wedding-text-body">我們已發送確認連結到您的信箱</p>
        </div>

        <div className="mb-8">
          <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6">
            <div className="flex items-start">
              <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <p className="text-green-700 font-medium mb-1">註冊成功！</p>
                <p className="text-green-600 text-sm">
                  確認郵件已發送到 <strong>{email}</strong>
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4 text-sm text-wedding-text-body">
            <p>請按照以下步驟完成帳號啟動：</p>
            <ol className="list-decimal list-inside space-y-2 ml-4">
              <li>檢查您的電子郵件收件箱</li>
              <li>找到來自{BRAND_CONFIG.name}的確認郵件</li>
              <li>點擊郵件中的「確認帳號」連結</li>
              <li>返回此頁面並登入您的帳號</li>
            </ol>
          </div>
        </div>

        {resendMessage && (
          <div className={`mb-4 p-3 rounded-md text-sm ${
            resendMessage.includes('失敗') || resendMessage.includes('錯誤')
              ? 'bg-red-50 border border-red-200 text-red-600'
              : 'bg-wedding-action/5 border border-wedding-action/20 text-wedding-text-body'
          }`}>
            {resendMessage}
          </div>
        )}

        <div className="space-y-4">
          <button
            onClick={handleResendEmail}
            disabled={isResending}
            className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-wedding-action focus:border-wedding-action transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isResending ? (
              <>
                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                處理中...
              </>
            ) : (
              <>
                <RefreshCw className="w-4 h-4 mr-2" />
                沒收到郵件？
              </>
            )}
          </button>

          <button
            onClick={onBack}
            className="w-full flex items-center justify-center px-4 py-2 bg-wedding-action text-white rounded-md hover:bg-wedding-action-hover focus:ring-2 focus:ring-wedding-action focus:ring-offset-2 transition-all"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            返回登入
          </button>
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            沒有收到郵件？請檢查垃圾郵件文件夾，或點擊上方按鈕重發確認郵件。
          </p>
        </div>
      </div>
    </div>
  );
};